<div class="row d-flex flex-wrap">
    <div class="col-lg">
        <div class="card radius-10">
            <div class="card-body">
                <div class="d-flex align-items-center">
                    <div>
                        <p class="mb-0 text-secondary">Total Team Members</p>
                        <h4 class="my-1">{{milestoneCard?.totalTeamMembers}}</h4>
                    </div>
                    <div class="widgets-icons bg-light-success text-success ms-auto"><i class='bx bxs-wallet'></i></div>
                </div>
                <div id="chart1"></div>
            </div>
        </div>
    </div>
    <div class="col-lg">
        <div class="card radius-10">
            <div class="card-body">
                <div class="d-flex align-items-center">
                    <div>
                        <p class="mb-0 text-secondary">Total Remaining Hours</p>
                        <h4 class="my-1">{{milestoneCard?.totalRemainingHours}}</h4>
                    </div>
                    <div class="widgets-icons bg-light-warning text-warning ms-auto"><i class='bx bxs-group'></i></div>
                </div>
                <div id="chart2"></div>
            </div>
        </div>
    </div>
    <div class="col-lg">
        <div class="card radius-10">
            <div class="card-body">
                <div class="d-flex align-items-center">
                    <div>
                        <p class="mb-0 text-secondary">Total Open Tasks</p>
                        <h4 class="my-1">{{milestoneCard?.totalOpenTasks}}</h4>
                    </div>
                    <div class="widgets-icons bg-light-danger text-danger ms-auto"><i class='bx bxs-binoculars'></i></div>
                </div>
                <div id="chart3"></div>
            </div>
        </div>
    </div>
    <div class="col-lg">
        <div class="card radius-10">
            <div class="card-body">
                <div class="d-flex align-items-center">
                    <div>
                        <p class="mb-0 text-secondary">Total Closed Tasks</p>
                        <h4 class="my-1">{{milestoneCard?.totalClosedTasks}}</h4>
                    </div>
                    <div class="widgets-icons bg-light-danger text-danger ms-auto"><i class='bx bxs-binoculars'></i></div>
                </div>
                <div id="chart4"></div>
            </div>
        </div>
    </div>
</div>

<div class="row">
    <div class="col-12 col-xl-6 d-flex">
        <div class="card radius-10 w-100">
            <div class="card-body">
                <div class="d-flex align-items-center">
                    <div>
                        <h5 class="mb-0">Milestone</h5>
                    </div>
                    <div class="text-center border-dotted ms-auto mt-2">
                        <button type="submit" id="save-btn" class="border-dotted-btn" (click)="createMilestone()">
                          <span class="text-primary mb-2">New Milestone</span>
                        </button>
                      </div>
                </div>
            </div>
            <div class="customers-list p-3 mb-3">
                <div class="customers-list-item d-flex align-items-center border-bottom p-2 cursor-pointer"
                    *ngFor="let milestone of milestones">
                    <div class="d-flex align-items-center w-100">
                        <h6 class="mb-0 font-1" style="width:150px">{{ milestone.projectName }}</h6>
                        <h6 class="mb-0 font-14" style="width:235px">{{ milestone.status }}</h6>
                            <h6 class="mb-0 font-14 me-3" >{{ milestone.startDate }}</h6>
                    </div>
                </div>
            </div>
            <div class=" mt-3 mb-3">
                <a href="#" class="milestone" routerLink="/project-pilot/milestones">
                    View More <i class='bx bx-chevron-right ms-1'></i>
                </a>
            </div>
        </div>
    </div>
</div>